import { gql } from '@/__generated__/storefront';

export const variantPointsPriceQuery = gql(`
  query variantPointsCost($id: ID!) {
    node(id: $id) {
    ... on ProductVariant {
      id
      metafield(key: "loyalty_points_cost", namespace: "hobbii") {
        value
      }
    }
  }
}`);
